import React from 'react'
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR } from '../../../configurations/initUrls'
import { EApplicationUserStatusBg, GetEApplicationUserStatusName } from '../../../configurations/enums/EApplicationUserStatus'

export default function Dp({
    user,
    height = "h-36",
    width = "w-36",
    isNewUser = false,
    ring = true,   // status ki colored ring dikhani hai ya nahi
}) {
    // image source nikaalo (DP hai to URL, warna gender ke hisaab se avatar)
    const imgSrc = user?.isDP == 0
        ? (user?.gender === 0 ? MALE_DR_AVATAR : FEMALE_DR_AVATAR)
        : BASE_URL + "/" + user?.dpUrl

    // status se ring ka color class (bg-*) — sirf tab jab status ho aur ring on ho
    const ringBg = ring && user?.status != null
        ? EApplicationUserStatusBg(user.status)
        : null

    const img = (
        <img
            className={`${height} ${width} rounded-full object-cover ${isNewUser ? 'mb-1' : 'inline-block'}`}
            src={imgSrc}
            alt={isNewUser ? "Doctor Image" : "Profile"}
        />
    )

    // ring nahi chahiye to seedha image
    if (!ringBg) return img

    // colored ring = bahar wala bg color + andar patli white gap
    return (
        <div
            className={`inline-block rounded-full p-1 ${ringBg}`}
            title={GetEApplicationUserStatusName(user.status)}
        >
            <div className="rounded-full bg-white p-0.5">
                {img}
            </div>
        </div>
    )
}